import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { localizeReducer } from "react-localize-redux";

import * as Account from './Account';
import * as ReportEmbedToken from './ReportEmbedToken';
import * as Notifications from './Notifications';
import * as Navigation from './Navigation';
import * as Action from './Action';
import * as Theme from './Theme';

export default function configureStore(history, initialState) {
	const reducers = {
		account: Account.reducer,
		reportEmbedToken: ReportEmbedToken.reducer,		
		notifications: Notifications.reducer,
		navigation: Navigation.reducer,
		action: Action.reducer,
		theme: Theme.reducer
	};

	const middleware = [
		thunk,
		routerMiddleware(history)
	];

	// In development, use the browser's Redux dev tools extension if installed
	const enhancers = [];
	const isDevelopment = process.env.NODE_ENV === 'development';
	if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
		enhancers.push(window.devToolsExtension());
	}

	const rootReducer = combineReducers({
		...reducers,
		routing: routerReducer,
		localize: localizeReducer,
	});

	return createStore(
		rootReducer,
		initialState,
		compose(applyMiddleware(...middleware), ...enhancers)
	);
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js